import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { map } from 'rxjs/operators';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.check().pipe(
    map((authenticated) => {
      if (authenticated) {
        // Already logged in → go to central selector
        return router.parseUrl('/main');
      }

      // Not authenticated → allow sign-in / forgot-password etc.
      return true;
    }),
  );
};
